import meta from '../metas/select';
import request from '../utils/request';
import TagList from '../components/tag-list';
import { readDataFromListPath } from '../utils/widgetUtils';
export default {
  components: {
    TagList
  },
  meta,
  props: {
    type: {
      type: String,
      default: 'select' // 显示为平铺（flat）还是下拉（select）视图

    },
    // 远程获取列表所需指定的参数对象
    remote: Object,
    valueKey: {
      type: String,
      default: 'value'
    },
    labelKey: {
      type: String,
      default: 'label'
    },
    formData: Object
  },
  data: () => ({
    loading: false,
    remoteData: []
  }),
  computed: {
    renderOptions() {
      if (!this.remote) {
        return this.$attrs.options;
      }

      return this.remoteData;
    }

  },

  created() {
    if (this.remote) {
      this.loadOptions();
    }
  },

  methods: {
    loadOptions() {
      const {
        formData = {}
      } = this;
      const {
        url,
        method,
        query = {},
        listQuery,
        listPath = 'data'
      } = this.remote;

      if (listQuery && formData) {
        listQuery.forEach(({
          name,
          relation
        }) => {
          query[name] = formData[relation];
        });
      }

      request({
        url,
        method,
        query
      }).then(res => {
        this.remoteData = readDataFromListPath(listPath, res);
      }).catch(e => {
        console.error(e);
        this.remoteData = [];
      });
    },

    // 处理级联下拉事件
    handleFormChange(newVal = {}, oldVal = {}) {
      if (this.remote && this.remote.listQuery) {
        let firstInit = false;
        const needUpdate = this.remote.listQuery.some(item => {
          const {
            relation
          } = item;
          const diff = newVal[relation] !== oldVal[relation];

          if (diff) {
            firstInit = oldVal[relation] === undefined;
          }

          return diff;
        });

        if (needUpdate) {
          this.loadOptions();

          if (!firstInit) {
            this.$emit('input', '');
          }
        }
      }
    }

  }
};